import React, { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import {
  ChevronDown,
  ChevronRight,
  Bell,
  Activity,
  Users,
  Award,
  MessageSquare,
  MessageCircle,
  Handshake,
  Heart,
  GraduationCap,
  Gift,
  Home,
  BookOpen,
  Calendar,
  Settings,
  LogOut,
  LayoutDashboard,
  Droplets,
  User,
  CreditCard,
  Menu,
  X,
  Search,
  ArrowLeft,
  DollarSign,
  BarChart3,
  Image,
} from "lucide-react";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openMenus, setOpenMenus] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const isAdmin = user?.user?.role === "admin";

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="flex h-screen w-full bg-gradient-to-br from-gray-50 to-gray-100 fixed inset-0">
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={toggleMobileMenu}
        />
      )}

      {/* Sidebar */}
      <div
        className={`${
          isSidebarOpen ? "w-72" : "w-20"
        } ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 fixed md:relative z-50 duration-300 bg-primary shadow-2xl h-full transition-all`}
      >
        {/* Sidebar Header */}
        <div className="p-4 border-b border-black border-opacity-20">
          <div className="flex items-center justify-between">
            {isSidebarOpen && (
              <div>
                <h2 className="text-xl font-bold text-white">ড্যাশবোর্ড</h2>
                <p className="text-white text-opacity-70 text-sm">
                  {isAdmin ? "অ্যাডমিন প্যানেল" : "সদস্য প্যানেল"}
                </p>
              </div>
            )}
            <button
              onClick={toggleSidebar}
              className="hidden md:block p-2 rounded-lg hover:bg-primary-focus text-white transition-colors duration-200"
            >
              {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {/* Menu Items */}
        <div className="py-4 overflow-y-auto max-h-[calc(100vh-120px)]">
          {isAdmin ? (
            <>
              <NavLink
                to="/dashboard"
                end
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 ${
                    isActive
                      ? "bg-white text-primary font-semibold shadow-md"
                      : "text-white hover:bg-primary-focus hover:text-white"
                  } rounded-xl mx-3 mb-2 transition-all duration-200 transform hover:scale-105`
                }
              >
                <LayoutDashboard size={20} />
                {isSidebarOpen && <span className="ml-3 font-medium">মূল ড্যাশবোর্ড</span>}
              </NavLink>


              {/* Finance Management */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("finance")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <DollarSign size={20} />
                    {isSidebarOpen && <span className="ml-3">আর্থিক ব্যবস্থাপনা</span>}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.finance ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.finance && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/finance-management"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">লেনদেন ব্যবস্থাপনা</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/financial-reports"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">আর্থিক রিপোর্ট</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Header Banner */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("headerBanner")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Home size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">হেডার ব্যানার</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.headerBanner ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.headerBanner && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-header-banner"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">নতুন ব্যানার যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/added-header-banner"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পূর্বের ব্যানার সমূহ</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Notice */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("notice")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Bell size={20} />
                    {isSidebarOpen && <span className="ml-3">নোটিশ</span>}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.notice ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.notice && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-notice"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">নতুন নোটিশ যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/manage-notices"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পূর্বের নোটিশ সমূহ</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Blood Donor */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("bloodDonor")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Droplets size={20} />
                    {isSidebarOpen && <span className="ml-3">ব্লাড ডোনার</span>}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.bloodDonor ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.bloodDonor && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-blood-donor"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">নতুন ব্লাড ডোনার যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/manage-blood-donor"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পূর্বের ব্লাড ডোনার বৃন্দ</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Activities */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("activities")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Activity size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">সাম্প্রতিক কার্যক্রম</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.activities ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.activities && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-activity"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">নতুন কার্যক্রম যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/activities"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পূর্বের কার্যক্রম সমূহ</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/categories"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">বিভাগসমূহ</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Members */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("members")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Users size={20} />
                    {isSidebarOpen && <span className="ml-3">সদস্য</span>}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.members ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.members && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-member"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">কার্যকরী সদস্য যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/all-member"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">সকল কার্যকরী সদস্য</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/add-public-university-student"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">
                        পাবলিক বিশ্ববিদ্যালয়ের শিক্ষার্থী যুক্ত করুন
                      </span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/all-public-university-student"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">
                        পাবলিক বিশ্ববিদ্যালয়ের শিক্ষার্থী
                      </span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/all-user"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">সকল ব্যবহারকারীর তালিকা</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Scholarship */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("scholarship")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <GraduationCap size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">শিক্ষা বৃত্তি</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.scholarship ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.scholarship && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/scholarship-application"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">সকল আবেদন</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Meritorious Students */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("meritorious")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Award size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">মেধাবী শিক্ষার্থী সংবর্ধনা</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.meritorious ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.meritorious && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/meritorious-student"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">সকল আবেদন</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Adviser Message */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("adviserMessage")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <MessageCircle size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">প্রধান উপদেষ্টার বাণী</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.adviserMessage ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.adviserMessage && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-adviser-message"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">বাণী যুক্ত করুন</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* President Message */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("presidentMessage")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <MessageSquare size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">প্রতিষ্ঠাতা সভাপতির বাণী</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.presidentMessage ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.presidentMessage && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-president-message"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">বাণী যুক্ত করুন</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Donor & Partner */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("donorPartner")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Handshake size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">ডোনার ও পার্টনার</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.donorPartner ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.donorPartner && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-donor-partner"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">ডোনার ও পার্টনার যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/donor-partner"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">
                        পূর্বের ডোনার ও পার্টনার সমূহ
                      </span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Provide Help */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("provideHelp")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Heart size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">সহযোগিতা প্রদান</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.provideHelp ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.provideHelp && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/add-provide-help"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">সহযোগিতা প্রদান যুক্ত করুন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/provide-help"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পূর্বের সহযোগিতা প্রদান সমূহ</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Milan Mela */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("milanMela")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <Calendar size={20} />
                    {isSidebarOpen && (
                      <span className="ml-3">মিলন মেলা ২০২৩</span>
                    )}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.milanMela ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>
                {openMenus.milanMela && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/picnic/application"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">সকল নিবন্ধন</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/* Logo Management */}
              <NavLink
                to="/dashboard/logo-management"
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 ${
                    isActive
                      ? "bg-white text-primary font-bold"
                      : "text-white hover:bg-primary-focus"
                  } rounded-lg mx-2 mb-1`
                }
              >
                <Image size={20} />
                {isSidebarOpen && <span className="ml-3">লোগো ব্যবস্থাপনা</span>}
              </NavLink>

              {/* Video Gallery Management */}
              <NavLink
                to="/dashboard/video-gallery-management"
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 ${
                    isActive
                      ? "bg-white text-primary font-bold"
                      : "text-white hover:bg-primary-focus"
                  } rounded-lg mx-2 mb-1`
                }
              >
                <Image size={20} /> {/* Using Image icon for now */}
                {isSidebarOpen && <span className="ml-3">ভিডিও গ্যালারি ব্যবস্থাপনা</span>}
              </NavLink>
            </>
          ) : (
            <>
              {/* Member Dashboard Links */}
              <NavLink
                to="/dashboard"
                end
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 ${
                    isActive
                      ? "bg-white text-primary font-bold"
                      : "text-white hover:bg-primary-focus"
                  } rounded-lg mx-2 mb-1`
                }
              >
                <User size={20} />
                {isSidebarOpen && <span className="ml-3">প্রোফাইল</span>}
              </NavLink>

              <NavLink
                to="/dashboard/edit-profile"
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 ${
                    isActive
                      ? "bg-white text-primary font-bold"
                      : "text-white hover:bg-primary-focus"
                  } rounded-lg mx-2 mb-1`
                }
              >
                <Settings size={20} />
                {isSidebarOpen && <span className="ml-3">প্রোফাইল আপডেট</span>}
              </NavLink>

              {/* Payment Menu for Members */}
              <div className="mb-1 mx-2">
                <button
                  onClick={() => toggleMenu("payments")}
                  className="flex items-center justify-between w-full px-4 py-3 text-white hover:bg-primary-focus rounded-lg"
                >
                  <div className="flex items-center">
                    <CreditCard size={20} />
                    {isSidebarOpen && <span className="ml-3">পেমেন্ট</span>}
                  </div>
                  {isSidebarOpen &&
                    (openMenus.payments ? (
                      <ChevronDown size={18} />
                    ) : (
                      <ChevronRight size={18} />
                    ))}
                </button>

                {openMenus.payments && isSidebarOpen && (
                  <div className="pl-4 mt-1">
                    <NavLink
                      to="/dashboard/submit-payment"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পেমেন্ট জমা দিন</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/my-payments"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">আমার পেমেন্টসমূহ</span>
                    </NavLink>

                    <NavLink
                      to="/dashboard/payment-summary"
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-white text-primary font-bold"
                            : "text-white hover:bg-primary-focus"
                        } rounded-lg`
                      }
                    >
                      <span className="ml-3">পেমেন্ট সারাংশ</span>
                    </NavLink>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Common Settings Link */}
          {/* <NavLink
            to="/dashboard/settings"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 ${
                isActive
                  ? "bg-white text-primary font-bold"
                  : "text-white hover:bg-primary-focus"
              } rounded-lg mx-2 mb-1`
            }
          >
            <Settings size={20} />
            {isSidebarOpen && <span className="ml-3">সেটিংস</span>}
          </NavLink> */}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={toggleMobileMenu}
                className="md:hidden p-2 rounded-lg hover:bg-gray-100 text-gray-600"
              >
                <Menu size={20} />
              </button>
              
              {/* Back to Home Button */}
              <Link
                to="/"
                className="flex items-center space-x-2 px-4 py-2 bg-primary bg-opacity-10 hover:bg-primary hover:text-white text-primary rounded-lg transition-all duration-200 font-medium"
              >
                <ArrowLeft size={18} />
                <span className="hidden sm:inline">হোম পেজে ফিরুন</span>
                <span className="sm:hidden">হোম</span>
              </Link>
              
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  {isAdmin ? "অ্যাডমিন প্যানেল" : "ড্যাশবোর্ড"}
                </h1>
                <p className="text-sm text-gray-500">
                  স্বাগতম, {user?.user?.name || 'ব্যবহারকারী'}
                </p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              {/* Notifications */}
              <button className="relative p-2 rounded-lg hover:bg-gray-100 text-gray-600 transition-colors duration-200">
                <Bell size={20} />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>
              
              {/* User Profile */}
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white font-medium">
                  {(user?.user?.name || 'U').charAt(0).toUpperCase()}
                </div>
                <div className="hidden md:block">
                  <p className="text-sm font-medium text-gray-900">{user?.user?.name}</p>
                  <p className="text-xs text-gray-500">{isAdmin ? 'Administrator' : 'Member'}</p>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <main className="flex-1 overflow-auto bg-gradient-to-br from-gray-50 to-white p-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
